<template>
  <div class="card">
    <div class="card-header">
    </div>
    <div class="card-footer">
      
      <p-button v-if="token.length > 0" type="info" @click.prevent="callMonoConnect" class="info" round>Re-sync bank account</p-button>
      <p v-else-if="message.length > 0">{{ message }}</p>
      <p v-else-if="message.length ==0 || token.length == 0">Loading ...</p>
    </div>

  </div>
</template>
<script>
  export default {
    
    data () {
      return {
        message: '',
        token: '',
        model: {
          country: '',
          bank: '',
          number: '',
          linkAccountButtonText: 'Link Account'
        },
      }
    },
    methods: {
      callMonoConnect () {
        var connect;
        var config = {
          key: process.env.VUE_APP_MONO_LIVE_PUBLIC_KEY,
          onSuccess: function (response) {
            
            console.log(JSON.stringify(response));
           
          },
          onClose: function () {
            console.log('user closed the widget.')
          }
        };
        connect = new Connect(config);
        connect.reauthorise(this.token);
        
        connect.open()
      },

      monoScript () {
        let monoScript = document.createElement('script')
        monoScript.setAttribute('src', 'https://connect.withmono.com/connect.js')
        document.head.appendChild(monoScript)
      },

      getSnyc () {
        this.$http.get ('/accounts/mono/' + this.$route.params.id)
        .then(response => {

          if(response.data.length == 0 ) {
            return
          }
          console.log(response.data)

          if (response.data.token) {
            this.token = response.data.token
          }
          if (response.data.message.message) {
            this.message = response.data.message.message
          }
        })
        .catch(err => console.error(err))
      }
    },

    mounted () {
      this.getSnyc ()
      this.monoScript ()
    }
  }
</script>
